import { InviteAccountMemberRequestBody } from "@syla/shared/types/requests/InviteAccountMemberRequest";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function inviteAccountMember(
  accountId: string,
  props: InviteAccountMemberRequestBody,
): Promise<void> {
  try {
    await axios.post(`/accounts/${accountId}/access/invite`, props);
  } catch (error) {
    throwSylaApiError(error);
  }
}
